import { useMemo, useCallback } from 'react';
import Fuse from 'fuse.js';

const FUSE_OPTIONS = {
  threshold: 0.4,
  ignoreLocation: true,
};

export default function useFuzzySearch(items, field) {
  const fuse = useMemo(() => {
    if (!items || !field) return null;
    return new Fuse(items, { ...FUSE_OPTIONS, keys: [field] });
  }, [items, field]);

  return useCallback((term) => {
    if (!fuse || !term) return items || [];
    return fuse.search(term).map(result => result.item);
  }, [fuse, items]);
}
